import { INTERCOM_MODULE_NAME } from './moduleName';

export const GET_HMAC = `${INTERCOM_MODULE_NAME}/GET_HMAC`;
export const GET_HMAC_SUCCESS = `${INTERCOM_MODULE_NAME}/GET_HMAC_SUCCESS`;
export const GET_HMAC_ERROR = `${INTERCOM_MODULE_NAME}/GET_HMAC_ERROR`;

export const GET_UNREAD_MESSAGES = `${INTERCOM_MODULE_NAME}/GET_UNREAD_MESSAGES`;

export const SHUTDOWN_INTERCOM = `${INTERCOM_MODULE_NAME}/SHUTDOWN`;
